import {
    Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../../config/config';
import { BaseComponent } from '../../../../common/components/base.component';
import { isNullOrUndefined } from '../../../../common/extensions';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { VisitorTripStore } from '../../../../stores/visitor.calendar.store';

@Component({
    selector: 'ig-trip-map-bottom-info',
    templateUrl: './trip.map.bottom.info.component.html',
    styleUrls: ['./trip.map.bottom.info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TripMapBottomInfoComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public isShowingDetail: boolean;
    public greenMapIcon = config.detailSelectedMapMarker;
    @Input() item: any;
    @Input() isShowRemoveBtn: any;
    @Input() index: number;
    @ViewChild('description') description: ElementRef;
    @Output() showDetail: EventEmitter<any> = new EventEmitter();
    @Output() removeFromTrip: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    constructor(private router: Router,
                public imageService: ImageService,
                private visitorTripStore: VisitorTripStore,
                private visitorApiService: VisitorApiService,
                private activatedRoute: ActivatedRoute) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;

    }

    public get isDetailShowing() {
        return this.isShowingDetail;
    }

    public gotoDetails(item) {
        this.showDetail.emit(item);
    }

    public remove(item) {
        this.removeFromTrip.emit(item);
        this.isShowingDetail = false;
    }

    public show() {
        this.isShowingDetail = true;
    }
    public close() {
        this.isShowingDetail = false;
    }

    public isNullOrUndefined(value) {
        return isNullOrUndefined(value);
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component.ts